// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var RequestHeaders = /** @class */ (function () {
    function RequestHeaders() {
    }
    /**
     * Request-Context header
     */
    RequestHeaders.requestContextHeader = "Request-Context";
    /**
     * Target instrumentation header that is added to the response and retrieved by the
     * calling application when processing incoming responses.
     */
    RequestHeaders.requestContextTargetKey = "appId";
    /**
     * Request-Context appId format
     */
    RequestHeaders.requestContextAppIdFormat = "appId=cid-v1:";
    /**
     * Request-Id header
     */
    RequestHeaders.requestIdHeader = "Request-Id";
    /**
     * W3C distributed tracing protocol header
     */
    RequestHeaders.traceParentHeader = "traceparent";
    /**
     * Sdk-Context header
     * If this header passed with appId in content then appId will be returned back by the backend.
     */
    RequestHeaders.sdkContextHeader = "Sdk-Context";
    /**
     * String to pass in header for requesting appId back from the backend.
     */
    RequestHeaders.sdkContextHeaderAppIdRequest = "appId";
    RequestHeaders.requestContextHeaderLowerCase = "request-context";
    return RequestHeaders;
}());
export { RequestHeaders };
//# sourceMappingURL=RequestResponseHeaders.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/RequestResponseHeaders.js
// module id = 139
// module chunks = 1